import http from "../http-common";

class CourseService {
  createCourse(data) {
    return http.post(`/api/course`, data);
  }
  getCourses() {
    return http.get(`/api/course`);
  }
  updateCourse(id, data) {
    return http.put(`/api/course/${id}`, data);
  }
  getCourseFilter(nameTH) {
      return http.get(`/api/course/getCourseByFilter?nameTH=`+nameTH);
    }
}

export default new CourseService();